import { Avatar, Dropdown, Space, Badge } from "antd";
import { Bell, LogOut, Menu, User, Mail, Phone } from "lucide-react";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "~/store";
import { useSidebar } from "~/providers/sidebar.provider";

const Header: React.FC = () => {
  const { toggleMobileSidebar } = useSidebar();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="bg-[#fffff5] border-b-2 border-black sticky top-0 z-50">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center gap-4">
            <button
              onClick={toggleMobileSidebar}
              className="lg:hidden p-2 text-black hover:bg-[#fffef5] border-2 border-black transition-colors font-bold"
            >
              <Menu size={24} />
            </button>
            <Link to="/overview" className="flex items-center gap-3 group">
              <img 
                src="/logo.png" 
                alt="AHC Logo" 
                className="w-6 h-6"
              />
              <div className="hidden sm:flex flex-col">
                <span className="font-bold text-xl text-black uppercase tracking-wide leading-none">
                  Art Handler Collective
                </span>
                <span className="text-xs text-black tracking-widest uppercase font-bold mt-0.5">
                  Client Portal
                </span>
              </div>
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <Dropdown
              menu={{
                items: [
                  {
                    key: "contact",
                    label: (
                      <div className="flex flex-col gap-1 py-1">
                        <span className="font-bold text-black uppercase text-sm">
                          Contact Us
                        </span>
                      </div>
                    ),
                    disabled: true,
                  },
                  { type: "divider" },
                  {
                    key: "email",
                    label: (
                      <a
                        href="mailto:info@arthandlercollective.org"
                        className="flex items-center gap-2 font-bold uppercase text-sm text-black hover:text-black"
                      >
                        <Mail size={16} />
                        <span>info@arthandlercollective.org</span>
                      </a>
                    ),
                  },
                  {
                    key: "phone",
                    label: (
                      <a
                        href="tel:646-741-4047"
                        className="flex items-center gap-2 font-bold uppercase text-sm text-black hover:text-black"
                      >
                        <Phone size={16} />
                        <span>646-741-4047</span>
                      </a>
                    ),
                  },
                ],
              }}
              trigger={["click"]}
            >
              <button className="p-2.5 text-black hover:bg-[#fffef5] border-2 border-black transition-all font-bold">
                <Bell size={20} />
              </button>
            </Dropdown>

            <div className="h-8 w-0.5 bg-black" />

            <Dropdown
              menu={{
                items: [
                  {
                    key: "1",
                    label: (
                      <div className="flex flex-col gap-1 py-1">
                        <span className="font-bold text-black uppercase text-sm">
                          {user?.client?.companyName || 'My Account'}
                        </span>
                        <span className="text-xs text-black">
                          {user && user.username}
                        </span>
                      </div>
                    ),
                    disabled: true,
                  },
                  { type: "divider" },
                  {
                    key: "profile",
                    label: <span className="font-bold uppercase text-sm">Profile</span>,
                    icon: <User size={16} />,
                    onClick: () => navigate("/profile"),
                  },
                  {
                    key: "logout",
                    label: <span className="font-bold uppercase text-sm">Logout</span>,
                    icon: <LogOut size={16} />,
                    onClick: logout,
                    danger: true,
                  },
                ],
              }}
            >
              <Space className="cursor-pointer hover:opacity-80 transition-opacity">
                <div className="w-10 h-10 border-2 border-black bg-black flex items-center justify-center">
                  <User size={18} className="text-white" />
                </div>
              </Space>
            </Dropdown>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
